import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import Autosuggest from '@adv-mt/mt-form-autosuggest'

const USE_CASE = 'get_info_vehicles_use_case'

const FormModel = ({initialSearch = {}, value = {}, onChange, hasButton}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {makeId, categoryId} = initialSearch
  const params = {makeId, categoryId}

  const [models, setModels] = useState([])

  const _mapItems = ({items}) => {
    return items.map(({id, name: label}) => ({id, label}))
  }
  useEffect(() => {
    makeId &&
      domain
        .get(USE_CASE)
        .execute({
          nextField: FILTER_NAMES.MODEL,
          params
        })
        .then(response => {
          const items = _mapItems({...response})
          setModels(items)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [makeId, categoryId])

  const handleChange = (e, {id, value}) => {
    e.preventDefault()
    const currentValue = {id, name: value}
    onChange(e, {
      field: FILTER_NAMES.MODEL,
      value: currentValue,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.MODEL]
    })
  }

  return (
    <Autosuggest
      label={i18n.t('COMMON.PLURALS.MODEL', 1)}
      id="input-search-filter-model"
      options={models}
      value={value.name}
      onChange={handleChange}
      hasButton={hasButton}
    />
  )
}

FormModel.displayName = 'FormModel'
FormModel.propTypes = {
  initialSearch: PropTypes.shape({
    makeId: PropTypes.number,
    categoryId: PropTypes.number,
    model: PropTypes.string
  }),
  value: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired,
  hasButton: PropTypes.bool
}

export default FormModel
